module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAFtJREFUSA1jZCAdZKNpmYrGx8tlwitLA8lRC6keqKNBOhqkJIfA8E80jMAwQS8bSQ4mUjQM/yCluw9BcUgqQI/z0foQJQTpHoejFqKEPzU4o0FKjVBEMWP4BykAeq8CoVj5/b0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/plus-1.png
// module id = 1165
// module chunks = 0